import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiGeneralConfig() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const url = BASEURL + "generalConfig/";

  return {
    GetAll: () => authAxios.get(url + "Get"),
    Update: (id, record) =>
      authAxios.put(url + "Update/" + id, record),
    Delete: (id) =>
      authAxios.delete(url + "DeleteEntity/" + id),
    Add: (record) =>
      authAxios.post(url + "Add/", record),
  };
}

export default ApiGeneralConfig;
